import { SettingsObject } from '@hooks/useSettings';

export const defaults: Partial<SettingsObject> = {
    currency: 'HUF',
    showClickAndCollect: true,
    enableEnergyLabelLink: true,
};
